import { z } from "zod";

export const InvoiceSourceSchema = z.enum(["ksef", "fakturownia", "csv", "subiekt123", "nota"]);
export type InvoiceSource = z.infer<typeof InvoiceSourceSchema>;

export const InvoiceStatusSchema = z.enum(["unpaid", "paid"]);
export type InvoiceStatus = z.infer<typeof InvoiceStatusSchema>;

export const InvoiceTypeSchema = z.enum(["sales", "cost"]);
export type InvoiceType = z.infer<typeof InvoiceTypeSchema>;

// Feature 018: deterministic classification derived from bank_account vs configured client account
export const InvoiceClassificationSchema = z.enum(["client_invoice", "business_invoice"]);
export type InvoiceClassification = z.infer<typeof InvoiceClassificationSchema>;

export const InvoiceSchema = z.object({
  id: z.string().uuid(),
  source: InvoiceSourceSchema,
  invoice_type: z.string(),
  invoice_number: z.string(),
  client_id: z.string().uuid(),
  client_name: z.string().optional(),
  issue_date: z.string().date(),
  due_date: z.string().date().nullable(),
  net_amount: z.string().regex(/^\d+\.\d{2}$/),
  gross_amount: z.string().regex(/^\d+\.\d{2}$/),
  vat_amount: z.string().regex(/^\d+\.\d{2}$/),
  status: InvoiceStatusSchema,
  paid_at: z.string().datetime({ offset: true }).nullable(),
  days_overdue: z.number().int().min(0).nullable(),
  payment_match_status: z.string().nullable().optional(),
  payment_match_confidence: z.string().nullable().optional(),
  payment_date: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  nota_r2_key: z.string().nullable().optional(),
  payment_source: z.enum(["manual"]).nullable().optional(),
  payment_account_type: z.enum(["client", "operational"]).nullable().optional(),
  bank_account: z.string().nullable().optional(),
  classification: InvoiceClassificationSchema.optional(),
});
export type Invoice = z.infer<typeof InvoiceSchema>;

export const InvoiceListResponseSchema = z.object({
  invoices: z.array(InvoiceSchema),
  total: z.number().int().min(0),
});
export type InvoiceListResponse = z.infer<typeof InvoiceListResponseSchema>;

export const InvoiceListQuerySchema = z.object({
  status: InvoiceStatusSchema.optional(),
  client_id: z.string().uuid().optional(),
  source: InvoiceSourceSchema.optional(),
  invoice_type: InvoiceTypeSchema.optional(),
  from: z.string().date().optional(),
  to: z.string().date().optional(),
  payment_account_type: z.enum(["client", "operational"]).optional(),
});
export type InvoiceListQuery = z.infer<typeof InvoiceListQuerySchema>;
